/**
 * A custom element that manages the account login actions.
 *
 * @extends {HTMLElement}
 */
class AccountLoginActions extends HTMLElement {
  /**
   * @type {Element | null}
   */
  shopLoginButton = null;

  connectedCallback() {
    this.shopLoginButton = this.querySelector('shop-login-button');

    if (this.shopLoginButton) {
      // We don't have control over the shop-login-button markup, so we need to set additional attributes here
      this.shopLoginButton.setAttribute('full-width', 'true');
      this.shopLoginButton.setAttribute('persist-after-sign-in', 'true');
      // Do this only if New Customer Account is ALWAYS the sign in option (and never Classic Customer Account)
      this.shopLoginButton.setAttribute('analytics-context', 'loginWithShopSelfServe');
      this.shopLoginButton.setAttribute('flow-version', 'account-actions-popover');
      this.shopLoginButton.setAttribute('return-uri', window.location.href);

      // Reload the page after the login is completed, otherwise the page state is incorrect
      this.shopLoginButton.addEventListener('completed', () => {
        window.location.reload();
      });
    }
  }
}

if (!customElements.get('account-login-actions')) {
  customElements.define('account-login-actions', AccountLoginActions);
}

/*
// hCaptcha validation pour le formulaire de contact (mode invisible) SANS initialisation manuelle
console.log('[ContactForm] Script chargé');
document.addEventListener('DOMContentLoaded', function () {
  console.log('[ContactForm] DOMContentLoaded');
  var contactForm = document.querySelector('.contact-form__form');
  if (contactForm) {
    console.log('[ContactForm] Formulaire trouvé');
    contactForm.addEventListener('submit', function (e) {
      console.log('[ContactForm] Soumission du formulaire');
      var hcaptchaResponse = document.querySelector('textarea[name="h-captcha-response"], input[name="h-captcha-response"]');
      if ((!hcaptchaResponse || !hcaptchaResponse.value)) {
        e.preventDefault();
        console.log('[ContactForm] hCaptcha non validé, exécution du challenge invisible');
        if (window.hcaptcha) {
          window.hcaptcha.execute();
        } else {
          alert('Le captcha n\'a pas pu être chargé.');
          console.error('[ContactForm] hCaptcha non chargé');
        }
      } else {
        console.log('[ContactForm] hCaptcha déjà validé, soumission normale');
      }
    });
  } else {
    console.warn('[ContactForm] Formulaire non trouvé');
  }
});

// Callback globale pour hCaptcha invisible avec logs
defineOnContactCaptchaSuccess();
function defineOnContactCaptchaSuccess() {
  window.onContactCaptchaSuccess = function(token) {
    console.log('[ContactForm] Callback hCaptcha appelé, token:', token);
    var hcaptchaResponse = document.querySelector('input[name="h-captcha-response"]');
    if (hcaptchaResponse) {
      hcaptchaResponse.value = token;
      console.log('[ContactForm] Champ h-captcha-response rempli');
    } else {
      console.warn('[ContactForm] Champ h-captcha-response introuvable');
    }
    var contactForm = document.querySelector('.contact-form__form');
    if (contactForm) {
      console.log('[ContactForm] Soumission du formulaire via callback');
      contactForm.submit();
    } else {
      console.warn('[ContactForm] Formulaire non trouvé dans le callback');
    }
  };
}
*/
